<div :class="['home-sidebar card legacy-card bg-blue border-0 shadow', { 'open': isSidebarOpen }]">
  <div class="card-body text-white">
    <ul class="nav-links">
      <li v-for="item in sidebar_menu_items" :key="item.default_label">
        <div class="icon-link">
          <a :href="item.href">
            <img :src="item.icon" :alt="item.label" class="home-sidebar-menu-icon" />
            <span class="link-name">{{ item.label }}</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</div>
